import React from 'react';
import { Check, CreditCard, DollarSign } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { formatNumberWithCommas } from './utils/creditUtils';

interface CustomCreditPackageProps {
  isSelected: boolean;
  onSelect: () => void;
  customAmount: string;
  onCustomAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  customPrice: number;
}

export const CustomCreditPackage: React.FC<CustomCreditPackageProps> = ({
  isSelected,
  onSelect,
  customAmount,
  onCustomAmountChange,
  customPrice,
}) => {
  return (
    <div
      className={`border-2 rounded-lg p-4 transition-all duration-200 cursor-pointer relative ${
        isSelected
          ? 'border-blue-500 bg-blue-50 shadow-lg ring-2 ring-blue-200'
          : 'border-gray-300 bg-white hover:border-blue-400 hover:bg-blue-25 hover:shadow-md'
      }`}
      onClick={onSelect}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-lg">Custom Amount</h3>
          
          <div className="mt-3 relative">
            <Input
              type="text"
              placeholder="Enter credit amount"
              value={customAmount}
              onChange={onCustomAmountChange}
              onClick={(e) => e.stopPropagation()}
              className="pl-8 pr-4 py-2 bg-white border-2 border-gray-300 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 rounded-md"
            />
            <DollarSign className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
          </div>
          
          {customAmount && (
            <>
              <div className="mt-2 text-lg font-semibold text-green-600">
                ${formatNumberWithCommas(customPrice)} USD
              </div>
              <div className="mt-2 text-sm font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-md inline-block">
                Tradeable AUM: ${formatNumberWithCommas(parseInt(customAmount.replace(/,/g, ''), 10) * 1000 || 0)}
              </div>
            </>
          )}
        </div>

        <div className="flex-shrink-0 ml-4">
          {isSelected ? (
            <div className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center shadow-md">
              <Check className="h-5 w-5 text-white" />
            </div>
          ) : (
            <div className="h-8 w-8 rounded-full border-2 border-gray-400 bg-white hover:border-blue-400 transition-colors"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomCreditPackage;
